export function isCrmRecordUnavailable(record = {}) {
  const sources = [record, record.raw, record.original].filter(Boolean);
  return sources.some((item) => item.deleted === true || item.isDeleted === true ||
    item.archived === true || item.isArchivedDuplicate === true || item.movedToBin === true ||
    ["archived", "deleted", "duplicate_archived", "archived_duplicate"].includes(String(item.status || item.dealStatus || "").toLowerCase()) ||
    ["in_bin", "deleted", "archived"].includes(item.binStatus) ||
    ["bin", "deleted", "archived"].includes(item.visibilityStatus));
}

export function isCrmTaskActionable(record = {}) {
  const task = record.crmTask || record.original || record;
  return !isCrmRecordUnavailable(task) && ["open", "pending"].includes(task.status || "open");
}
